import { PARTNER } from "@tm/isomorphic-utils";
import { deviceType } from "@tm/static/utils";
import styled from "styled-components";

export const InnerContentWrap = styled.div`
  width: 1200px;
  margin: 0 auto;
  ${(p) =>
    p.theme.pageTheme === PARTNER.MYBIZ
      ? `
    padding: 32px 40px;
    border-radius: 20px;
    box-shadow: 0px 3px 30px 0px #0000001A;
    background: white;`
      : null}
  @media screen and ${deviceType.mobile} {
    width: 100%;
  }
`;
